import { useMemo } from 'react';

import { TAdBannerPlaceParameters } from 'shared/types/adBannerMicrofrontend';

/**
 * Значения размещения должны совпадать с легаси-баннером (PikBannerInFiltersContainer),
 * иначе Adfox отдаст другую кампанию.
 */
const PLACE = 'additional_filters';
const P_PARAMS: TAdBannerPlaceParameters['pParams'] = { p1: 'crzye', p2: 'fmsa' };
const SIZES: TAdBannerPlaceParameters['sizes'] = { width: '100%', height: 100 };

/** Параметры места «баннер в расширенных фильтрах» */
export function useAdditionalFiltersParameters(): TAdBannerPlaceParameters {
  return useMemo(
    () => ({
      carousel: null,
      deviceType: 'desktop',
      galleryPosition: null,
      isSp: false,
      pParams: P_PARAMS,
      place: PLACE,
      position: null,
      sizes: SIZES,
      tgbNativedescGeneralDesign: null,
    }),
    [],
  );
}
